'use client';
import NavBar from "@/components/header/NavBar";
import GrowthPartner from "@/components/home-page/Growthpartner ";
import VideoHero from "@/components/home-page/VideoHero";
import HomeWorkSection from "@/components/home-page/HomeWorkSection";
import ContactForm from "@/components/home-page/ContactForm";
import Why from "@/components/home-page/whySection";
import TabsDemo from "@/components/home-page/tabs-demo";
import {MarqueeDemo} from "@/components/home-page/marqueeDemo";
import FAQContainer from "@/components/home-page/FAQContainer";
import Dubble from "@/components/home-page/dubbleSection";
import BlogSection from "@/components/home-page/blogSection";
import Footer from "@/components/footer/Footer";




export default function TestPage() {
 
 const workList = [
  {
    id: 1,
    title: "UI/UX Design",
    category:
      "We design intuitive, modern, and engaging digital experiences that are easy to use and built around your users and business goals.",
    image: "/work/work-1.avif",
  },
  {
    id: 2,
    title: "Web Development & SEO",
    category:
      "We build fast, secure, and scalable websites designed to perform. From clean development and technical SEO to performance optimization and search visibility, we create digital experiences that attract visitors and turn them into customers.",
    image: "/work/work-2.avif",
  },
  {
    id: 3,
    title: "Testing & Consulting",
    category:
      "We test web applications thoroughly to identify bugs, performance issues, usability problems, and potential risks. We also provide expert technical consulting to help you improve your product, choose the right solutions, and build with confidence.",
    image: "/work/work-3.avif",
  },
  {
    id: 4,
    title: "Maintenance & Support",
    category:
      "We keep your website or web application secure, updated, fast, and reliable with ongoing maintenance, monitoring, troubleshooting, and technical support.",
    image: "/work/work-5.avif",
  },
];

  



  return (
   <>
   
    <NavBar/>
<GrowthPartner/>
       <VideoHero
        posterSrc="/1.avif"
        videoSrc="https://res.cloudinary.com/daybtdlim/video/upload/v1792766665/section.mp4"
        heading="If We Take It On, We Do It Right."
        description="We work with businesses around the world to deliver exceptional websites and digital experiences designed for lasting results. Combining thoughtful design, powerful technology, secure hosting, ongoing maintenance, and expert consultation, we become a reliable digital partner from launch and beyond. Your goals, your success, and your satisfaction are at the heart of everything we do."
        ctaLabel="Schedule Meeting"
      />

       <HomeWorkSection workList={workList} />
       <ContactForm />
       <Why />

     <div className="bg-secondary rounded-b-3xl mb-96 lg:mb-32">
        <h1 className="text-white text-4xl lg:text-5xl 2xl:text-7xl font-bold px-4 lg:px-32 pt-16 text-center">
          Build and scale with us in your domain
        </h1>
        <TabsDemo />
      </div>
 <MarqueeDemo />
     <FAQContainer />
 <Dubble />

 <BlogSection />

<Footer />



   </>
  );
}

/**   
 *
<FullscreenVideo
  poster="/c.png"
  sources={[
    { src: "/videos/hero.webm", type: "video/webm" },
    { src: "/v.mp4", type: "video/mp4" },
  ]}
/>
 *  <Hero />
     <WidgetSpinner />
<ScrollAnimation/>
     <NewsSection/>
     <TextBlock/>
      <Nshop />
 *   <ScrollAnimation/> */